import { FlagOutline } from '@pyt/icons'
import themeGet from '@pyt/ui/utils/themeGet'
import { Fragment } from 'react'
import styled, { css } from 'styled-components'

import isEqual from '../../../utils/lodashUtils/isEqual'

const GroupButtonTitle = styled.label`
	color: #aaa;
	font-weight: 400;
	margin-bottom: 8px;
	font-size: 13px;
	line-height: 1.23;
	letter-spacing: -0.25px;
`

const GroupBtn = styled('section')`
	display: inline-block;
	margin-bottom: 0px;
	text-align: center;
	vertical-align: middle;
	touch-action: manipulation;
	border-style: solid;
	border-width: 1px;
	white-space: nowrap;
	border-radius: 8px;
	user-select: none;
	cursor: pointer;
	padding: 8px 12px;
	font-size: 16px;
	font-weight: 600;
	letter-spacing: -0.4px;
	line-height: 1.41;
	transition: all 0.2s ease 0s;

	${props =>
		props.active &&
		css`
			background: #1895b3;
			border-color: #1895b3;
			color: #ffffff;

			span,
			i {
				color: #ffffff;
			}
		`};
	${props =>
		props.isDisabled &&
		css`
			cursor: not-allowed;
		`};
	${props =>
		props.showOnHoverAnim &&
		css`
			&:hover {
				background-color: #e9fbff;
			}
		`};
`

const GroupButtonWrapper = styled.div`
	${props =>
		props.horizontal &&
		css`
			display: table;
			width: 100%;
			table-layout: fixed;
			border-collapse: initial;
		`};

	${GroupBtn} {
		border: 1px solid #c3c3c3;
		border-radius: 2px;
		background: ${themeGet('colors.white')};
		color: #1baacc;

		${props =>
			props.vertical &&
			css`
				width: 100%;
				margin-bottom: 8px;
				padding: 16px;
				font-weight: 600;
				font-size: 18px;
				line-height: 24px;
			`};

		${props =>
			props.horizontal &&
			css`
				font-size: 13px;
				line-height: 1.23;
				letter-spacing: -0.25px;
				font-weight: 400;
				border-radius: 1px;
				min-width: 76px;
				padding: 8px;
				margin: 0 6px 6px 0;
			`};
	}
`

const GroupButton = ({
	groupButtonTitle,
	groupButtonText = [],
	callBackAction,
	active = '',
	vertical = false,
	horizontal = false,
	showOnHoverAnim = false,
	children = null,
	isDisabled = false,
	trackerClassName = '',
}) => {
	const buttonClickAction = (e, index) => {
		e && e.preventDefault()
		callBackAction && callBackAction((groupButtonText[index] || {}).value)
	}

	return (
		<Fragment>
			{groupButtonTitle ? (
				<GroupButtonTitle>{groupButtonTitle}</GroupButtonTitle>
			) : null}

			<GroupButtonWrapper
				className={trackerClassName}
				vertical={vertical}
				horizontal={horizontal}
			>
				{(groupButtonText || []).map((groupDataObj, index) => {
					return (
						<Fragment key={index}>
							<GroupBtn
								key={index}
								onClick={e => buttonClickAction(e, index)}
								active={isEqual(active, groupDataObj.value)}
								showOnHoverAnim={showOnHoverAnim}
								isDisabled={isDisabled}
								className={groupDataObj.trackerClass}
							>
								{groupDataObj.text}
								{groupDataObj.flagText ? (
									<span className="block fine-text regular color-grey">
										<FlagOutline />
										&nbsp;{groupDataObj.flagText}
									</span>
								) : null}
							</GroupBtn>
						</Fragment>
					)
				})}
				{children}
			</GroupButtonWrapper>
		</Fragment>
	)
}

export default GroupButton
